import { Form } from "semantic-ui-react";
import StepInicio from "./StepInicio";
import StepDocumentos from "./StepDocumentos";
import StepCaracteristicas from "./StepCaracteristicas";
import StepConclusao from "./StepConclusao";
import { useState } from "react";
import logo from "./logo-pt2.png";
import BarraDeProgresso from "./components/BarraDeProgresso";
import { useNavigate } from "react-router-dom";

function NovoPedido() {
  const [step, setStep] = useState(1);
  const [dadosPedido, setDadosPedido] = useState({});
  const navigate = useNavigate();

  const frasesGuias = {
    1: "",
    2: "Que bom que você está aqui! Falta pouco para concluir seu pedido de filiação.",
    3: "Diversidade e inclusão é muito importante no PT.",
    4: "Bem vindo, bem vinda ao PT.",
    5: "Falta muito pouco! Já estou vendo uma esperança!",
    6: "Prontinho!",
  };

  const nextStep = () => {
    if (step >= 6) return;
    setStep(step + 1);
  };

  const previousStep = () => {
    if (step <= 1) return;
    setStep(step - 1);
  };
  

  const getStepComponent = (step) => {
    switch (step) {
      case 1:
        return (
          <StepInicio
            nextStep={nextStep}
            dadosPedido={dadosPedido}
            setDadosPedido={setDadosPedido}
          />
        );
      case 2:
        return (
          <StepDocumentos
            nextStep={nextStep}
            previousStep={previousStep}
            dadosPedido={dadosPedido}
            setDadosPedido={setDadosPedido}
          />
        );
      case 3:
        return (
          <StepCaracteristicas
            nextStep={nextStep}
            previousStep={previousStep}
            dadosPedido={dadosPedido}
            setDadosPedido={setDadosPedido}
          />
        );
      case 4:
      case 5:
        return navigate("/confirmar-identidade");
      case 6:
        return (
          <StepConclusao
            nextStep={nextStep}
            previousStep={previousStep}
            dadosPedido={dadosPedido}
            setDadosPedido={setDadosPedido}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className={`${step > 1 ? null : 'sistema'}`}>
    <div className={`formFiliacao ${step > 1 ? 'formCentral' : ''}`}>
      <div className="logo">
        <img src={logo} alt="logo pt"/>
      </div>
      <div className="fraseGuia">{frasesGuias[step]}</div>
      <BarraDeProgresso step={step} />
      <div className="formCampos">
        <Form>{getStepComponent(step)}</Form>
      </div>
    </div>
    </div>
  );
}

export default NovoPedido;
